import React from 'react'

import {
    AppListHeaderDiv,
    AppNameDiv,
    TagsDiv
} from  '../../Styles/Components/AppListHeaderStyles'

function AppListHeader(props){
    return (
        <AppListHeaderDiv>
            <AppNameDiv>Application Name</AppNameDiv>
            <TagsDiv>Tags</TagsDiv>
        </AppListHeaderDiv>
    )
}

export default AppListHeader